import classNames from 'classnames';

import { usePriceFormatter } from '../../hooks/usePriceFormatter';
import { OfferStatusOption } from '../../types/offer.types';
import { OrderType } from '../../types/order.types';

type Props = {
  order: OrderType;
  lg?: boolean;
  isSeller?: boolean;
};

export const ProductPriceWithOffer = ({ order, lg = false, isSeller }: Props) => {
  const formatPrice = usePriceFormatter();

  const price = isSeller
    ? formatPrice(order?.sellerSideOrderTotalPrice)
    : order?.vouchers_applied?.length
      ? formatPrice(order?.total)
      : formatPrice(order?.product?.price);

  return (
    <div className="product-price-with-offer">
      {order?.offer?.status === OfferStatusOption.COMPLETED && price !== formatPrice(order.product.priceWithoutOffer) ? (
        <>
          {price}
          <span className={classNames('old-price', { lg })}>{formatPrice(order.product.priceWithoutOffer)}</span>
        </>
      ) : (
        price
      )}
    </div>
  );
};
